import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams } from 'react-router-dom';

import {
  fieldObjectRepresentantesOuComunicacoes as fieldObject,
  headersHistoricoRT,
} from './auxiliarFornecedores';
import SubAbasFornecedores from './subabasFornecedores';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import Select from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import Modal from '../../../../components/Modal';
import Status from '../../../../components/Status';
import SubAbas from '../../../../components/SubAbas';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { useCpfValidation } from '../../../../modules/hooks/useCpfValidation';
import { LogData } from '../../../../modules/types/types';
import { useCargoFuncao } from '../../../../services/enum/useCargoFuncao';
import { useGeneros } from '../../../../services/enum/useGeneros';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { getFornecedor } from '../../../../services/fornecedoresDAF/fornecedorService';
import { getRepresentantesByFornecedor } from '../../../../services/fornecedoresDAF/representantesService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formataCPF,
  formataNomeMeioSiglas,
  formatDate,
  sanitizarForm,
} from '../../../../utils/functions';
import {
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../utils/swal';

//Dados do usuário
const user = getUser();
const userID = user.sub;
const entity = ENTITY.ENTITY_FornecedorRepresentante;

function HistoricoRT() {
  const [usuarioVinculadoSelecionado, setUsuarioVinculadoSelecionado] =
    useState<any>(null);
  const handleRowClickUsuarioVinculado = (id: string) => {
    const usuario = usuariosVinculados.find((item) => item.id === id);
    if (usuario) {
      setUsuarioVinculadoSelecionado(usuario);
      setShowModal(true);
    }
  };

  //PERMISSOES
  const params = useParams();
  const fichaID = String(params.id);

  // Dados do módulo
  const subAbas = SubAbasFornecedores(fichaID);
  const generoOptions = useGeneros();
  const cargoOptions = useCargoFuncao();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [representanteId] = useState<string>('');
  const [updating] = useState<boolean>(false);
  const [logData, setLogData] = useState<LogData>();
  const [data, setData] = useState<any[]>([]);

  const [formRepresentante, setFormRepresentante] = useState({
    generoSexual: 0,
    cargoFuncao: 0,
    cpf: '',
    nomeCompleto: '',
    dataNascimento: '',
    telefone: '',
    celular: '',
    email: '',
    linkedin: '',
    observacoes: '',

    // chave usuário
    usuarioRegistroId: userID,
    // chave fornecedor
    fornecedorId: parseInt(fichaID, 10),
  });

  const [formFornecedor, setFormFornecedor] = useState({
    fornecedorId: 0,
    cnpj: '',
    razaoSocial: '',
    ip: '',
  });

  //Filtro
  const [formFiltros, setFormFiltros] = useState({
    cargoFuncao: 0,
    nomeCompleto: '',
    celular: '',
    email: '',
  });

  let tituloModal = '';
  if (updating) {
    tituloModal = 'Atualizar Registro';
  } else {
    tituloModal = 'Novo Registro';
  }
  const iconeModal = 'warehouse';

  // Buscar dados
  const fetchData = async (id: string) => {
    try {
      const representantesData = await getRepresentantesByFornecedor(id);
      const fornecedorData = await getFornecedor(id);
      setData(representantesData);
      setFormRepresentante({
        generoSexual: representantesData.generoSexual,
        cargoFuncao: representantesData.cargoFuncao,
        cpf: representantesData.cpf,
        nomeCompleto: representantesData.nomeCompleto,
        dataNascimento: representantesData.dataNascimento,
        telefone: representantesData.telefone,
        celular: representantesData.celular,
        email: representantesData.email,
        linkedin: representantesData.linkedin,
        observacoes: representantesData.observacoes,

        // chave usuário
        usuarioRegistroId: userID,
        // chave fornecedor
        fornecedorId: parseInt(fichaID, 10),
      });
      setFormFornecedor({
        fornecedorId: fornecedorData.id,
        cnpj: fornecedorData.cnpj,
        razaoSocial: fornecedorData.razaoSocial,
        ip: fornecedorData.ip || '',
      });
      setLogData({
        id: representantesData.id,
        usuarioRegistro: representantesData.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao:
          representantesData.usuarioAtualizacao?.nomeCompleto || '',
        dataRegistro: representantesData.dataRegistro,
        dataAtualizacao: representantesData.dataUltimaAtualizacao,
        nEdicoes: representantesData.nEdicoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData(fichaID);
  }, []);

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    cpf: item.cpf,
    nomeCompleto: item.nomeCompleto,
    cargoFuncao: cargoOptions[item.cargoFuncao].label,
    dataNascimento: item.dataNascimento,
    generoSexual: generoOptions[item.generoSexual].label,
    celular: item.celular,
    telefone: item.telefone,
    email: item.email,
    linkedin: item.linkedin,
    observacoes: item.observacoes,
  }));

  const exportData = data.map((item) => ({
    //Dados da entidade
    id: item.id,
    nomeCompleto: item.nomeCompleto,
    cpf: item.cpf,
    cargoFuncao: cargoOptions[item.cargoFuncao].label,
    dataNascimento: item.dataNascimento,
    generoSexual: generoOptions[item.generoSexual].label,
    celular: item.celular,
    telefone: item.telefone,
    email: item.email,
    linkedin: item.linkedin,
    observacoes: item.observacoes,

    //Dados do Fornecedor
    fornecedorId: formFornecedor.fornecedorId,
    cnpj: formFornecedor.cnpj,
    razaoSocial: formFornecedor.razaoSocial,

    //Logs
    dataRegistro: item.dataRegistro,
    dataUltimaAtualizacao: item.dataUltimaAtualizacao,
    dataUltimaVisualizacao: item.dataUltimaVisualizacao,
    usuarioRegistro: formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    usuarioAtualizacao: formataNomeMeioSiglas(
      item.usuarioAtualizacao.nomeCompleto,
    ),
    usuarioUltimaVisualizacao: formataNomeMeioSiglas(
      item.usuarioUltimaVisualizacao.nomeCompleto,
    ),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
  }));

  // Validação CPF
  const [cpfDigits, setCpfDigits] = useState<number>(0);
  const [validCpf] = useCpfValidation({ cpf: formRepresentante.cpf });

  const validaCPF = () => {
    if (cpfDigits > 0) {
      if (!validCpf) {
        swalErro('O CPF digitado não é válido. Digite novamente.');
        setFormRepresentante({ ...formRepresentante, cpf: '' });
      }
    }
  };

  // Funções Handle
  const handleChangeForm = (e: any) => {
    const { name, value } = e.target;
    const newValue = parseInt(value, 10);
    if (name === 'cargoFuncao') {
      setFormRepresentante({
        ...formRepresentante,
        cargoFuncao: newValue,
      });
    } else if (name === 'genero') {
      setFormRepresentante({
        ...formRepresentante,
        generoSexual: newValue,
      });
    } else {
      setFormRepresentante((prev) => ({ ...prev, [name]: value }));
    }
    // Conta dígitos do CPF
    if (name === 'cpf') {
      setCpfDigits(e.target.value.replace(/\D/g, '').length);
    }
  };

  const handleChangeFiltros = (e: any) => {
    const { name, value } = e.target;
    if (name === 'cargoFuncao') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        cargoFuncao: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      cargoFuncao: 0,
      nomeCompleto: '',
      celular: '',
      email: '',
    });
  };

  // const handleClearForm = () => {
  //   setFormRepresentante({
  //     ...formRepresentante,
  //     generoSexual: 0,
  //     cargoFuncao: 0,
  //     cpf: '',
  //     nomeCompleto: '',
  //     dataNascimento: '',
  //     telefone: '',
  //     celular: '',
  //     email: '',
  //     linkedin: '',
  //     observacoes: '',

  //     // chave usuário
  //     usuarioRegistroId: userID,
  //     // chave fornecedor
  //     fornecedorId: parseInt(fichaID, 10),
  //   });
  // };

  const handleShowModal = () => {
    setShowModal((show) => !show);
  };

  // const handleClickInserirNovo = () => {
  //   handleClearForm();
  //   setUpdating(false);
  //   handleShowModal();
  // };

  // const handleRowClick = (id: string) => {
  //   setRepresentanteId(id);
  //   setUpdating(true);
  //   setShowModal(true);
  //   data
  //     .filter((item) => item.id == id)
  //     .map((item: any) => {
  //       setFormRepresentante({
  //         generoSexual: item.generoSexual,
  //         cargoFuncao: item.cargoFuncao,
  //         cpf: item.cpf,
  //         nomeCompleto: item.nomeCompleto,
  //         dataNascimento: item.dataNascimento,
  //         telefone: item.telefone,
  //         celular: item.celular,
  //         email: item.email,
  //         linkedin: item.linkedin,
  //         observacoes: item.observacoes,

  //         // chave usuário
  //         usuarioRegistroId: userID,
  //         // chave fornecedor
  //         fornecedorId: parseInt(fichaID, 10),
  //       });
  //       setLogData({
  //         id: item.id,
  //         usuarioRegistro: item.usuarioRegistro.nomeCompleto || '',
  //         usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto || '',
  //         dataRegistro: item.dataRegistro,
  //         dataAtualizacao: item.dataUltimaAtualizacao,
  //         nEdicoes: item.nEdicoes,
  //       });
  //     });
  // };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo

    if (!form.cpf) {
      errors.push('<b>CPF</b> é obrigatório.');
    }

    if (!form.generoSexual) {
      errors.push('<b>Gênero</b> é obrigatório.');
    }

    if (!form.cargoFuncao) {
      errors.push('<b>Cargo</b> é obrigatório.');
    }

    if (!form.nomeCompleto) {
      errors.push('<b>Nome Completo</b> é obrigatório.');
    }

    if (!form.dataNascimento) {
      errors.push('<b>Data de Nascimento</b> é obrigatório.');
    }

    if (!form.celular) {
      errors.push('<b>Celular</b> é obrigatório.');
    }

    if (!form.email) {
      errors.push('<b>Email</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    try {
      const formAjustado = {
        ...formRepresentante,
        dataNascimento: new Date(formatDate(formRepresentante.dataNascimento)),
      };

      const formToSend = sanitizarForm(formAjustado);
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formToSend);
      if (!isFormValid) return;

      await httpClient.post(`/api/fornecedorrepresentante`, formToSend);

      swalSave();
      fetchData(fichaID);
      setTimeout(() => handleShowModal(), 2500);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
    }
  };

  const handleUpdate = async () => {
    try {
      const formAjustado = {
        ...formRepresentante,
        dataNascimento: new Date(formatDate(formRepresentante.dataNascimento)),
      };

      const formToSend = sanitizarForm(formAjustado);
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formToSend);
      if (!isFormValid) return;

      const response = await httpClient.patch(
        `/api/fornecedorrepresentante/${representanteId}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registroAtualizado.fornecedor.id);
      setTimeout(() => {
        setShowModal(false);
      }, 2000);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();

    if (result) {
      try {
        await httpClient.delete(
          `/api/fornecedorrepresentante/${representanteId}`,
        );
        swalDeleteConfirm();
        fetchData(fichaID);
        setTimeout(() => {
          setShowModal(false);
        }, 2000);
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  //Modal para vincular novo usuário

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showModalVinculoUsuario, setShowModalVinculoUsuario] =
    useState<boolean>(false);

  // const [formVinculoUsuario] = useState<{
  //   id: string;
  //   tpVinculo: number;
  // }>({
  //   id: '0',
  //   tpVinculo: 0,
  // });

  const handleShowModalVinculoUsuario = () => {
    setShowModalVinculoUsuario((prev) => !prev);
  };

  // const [usuarioEncontrado] = useState<any>(null);
  const [usuariosVinculados, setUsuariosVinculados] = useState<any[]>([]);

  const fetchUsuariosVinculadosPorCnpj = async () => {
    try {
      const cnpjLimpo = formFornecedor.cnpj.replace(/\D/g, '');

      if (!cnpjLimpo) {
        console.warn(
          'CNPJ ou IP não disponíveis para consulta de usuários vinculados.',
        );
        return;
      }

      const response = await httpClient.get(`/api/usuariointerface`, {
        params: {
          cnpj: cnpjLimpo,
          stRegistroAtivo: 'N',
        },
      });
      setUsuariosVinculados(response.data.relacoes || []);
    } catch {
      setUsuariosVinculados([]);
    }
  };

  const valoresExibidos = {
    nome: 'Nome',
    cpf: 'CPF',
    celular: 'Celular',
    email: 'Email',
    dataVinculacao: 'Data de Vinculação',
    responsavelVinculacao: 'Responsável pela Vinculação',
    tpVinculo: 'Perfil',
    status: 'Status',
  };

  const tiposVinculo = {
    1: 'Representante Técnico',
    2: 'Fornecedor',
  } as const;

  // Mantenha a lógica do segundo código para tableData
  const tableData = usuariosVinculados.map((item) => ({
    // id: item.id,
    nome: item.usuarioId?.nomeCompleto || '---',
    cpf: formataCPF(item.usuarioId?.cpf) || '---',
    celular: item.usuarioId?.celular || '---',
    email: item.usuarioId?.emailPessoal || '---',
    responsavelVinculacao: item.usuarioVinculacao?.nomeCompleto || '---',
    dataVinculacao: formatDate(item.dataVinculacao),
    dataDesvinculacao: formatDate(item.dataDesvinculacao),
    tpVinculo: tiposVinculo[item.tpVinculo as 1 | 2] || '---',
    status: (
      <Status
        label={item.statusInterface === 'S' ? 'Ativo' : 'Pendente'}
        color={
          item.statusInterface === 'S'
            ? 'rgba(9, 175, 9, 0.655)'
            : 'rgba(200, 50, 50, 0.7)'
        }
        icon={
          item.statusInterface === 'N' ? FaCheckCircle : FaExclamationTriangle
        }
      />
    ),
  }));

  useEffect(() => {
    fetchData(fichaID);
  }, [fichaID]);

  useEffect(() => {
    if (formFornecedor.cnpj) {
      fetchUsuariosVinculadosPorCnpj();
    }
  }, [formFornecedor.cnpj]);

  // const validateFormVinculo = () => {
  //   const errors: string[] = [];

  //   if (!formVinculoUsuario.tpVinculo || formVinculoUsuario.tpVinculo === 0) {
  //     errors.push('<b>Tipo de Vínculo</b> é obrigatório.');
  //   }

  //   if (!usuarioEncontrado) {
  //     errors.push('<b>Usuário</b> deve ser pesquisado e selecionado.');
  //   }

  //   if (errors.length > 0) {
  //     swalAttention(errors.join('<br>'));
  //     return false;
  //   }

  //   return true;
  // };

  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/fornecedores/fornecedores"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            // backgroundColor: '#E1ECFE',
            backgroundColor: '#C5D4EB',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <Modal
          icone={iconeModal}
          tituloModal={tituloModal}
          open={showModal}
          onHide={handleShowModal}
        >
          <WorkspaceFicha>
            <Log {...logData} />
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol width="15%">
                <Input
                  name="cpf"
                  mascara="cpf"
                  value={formRepresentante.cpf}
                  id="cpf"
                  label="CPF"
                  onChange={handleChangeForm}
                  onBlur={validaCPF}
                  required
                />
              </CustomCol>
              <CustomCol width="45%">
                <Input
                  name="nomeCompleto"
                  value={formRepresentante.nomeCompleto}
                  id="nome"
                  label="Nome Completo"
                  onChange={handleChangeForm}
                  required
                />
              </CustomCol>
              <CustomCol width="20%">
                <Input
                  name="dataNascimento"
                  type="date"
                  value={formRepresentante.dataNascimento}
                  id="dataNascimento"
                  label="Data de Nascimento"
                  onChange={handleChangeForm}
                />
              </CustomCol>
              <CustomCol width="20%">
                <Select
                  name="cargoFuncao"
                  value={formRepresentante.cargoFuncao}
                  options={cargoOptions}
                  onChange={handleChangeForm}
                  label="Cargo"
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="15%">
                <Select
                  name="genero"
                  value={formRepresentante.generoSexual}
                  options={generoOptions}
                  onChange={handleChangeForm}
                  label="Gênero"
                />
              </CustomCol>
              <CustomCol width="15%">
                <Input
                  name="telefone"
                  value={formRepresentante.telefone}
                  id="celular"
                  mascara="celular"
                  label="Telefone"
                  onChange={handleChangeForm}
                />
              </CustomCol>
              <CustomCol width="15%">
                <Input
                  name="celular"
                  value={formRepresentante.celular}
                  id="celular"
                  mascara="celular"
                  label="Celular"
                  onChange={handleChangeForm}
                  required
                />
              </CustomCol>
              <CustomCol width="30%">
                <Input
                  name="email"
                  value={formRepresentante.email}
                  id="email"
                  label="Email"
                  onChange={handleChangeForm}
                  required
                />
              </CustomCol>
              <CustomCol width="25%">
                <Input
                  name="linkedin"
                  value={formRepresentante.linkedin}
                  id="linkedin"
                  label="LinkedIn"
                  onChange={handleChangeForm}
                  required
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <Col>
                <Input
                  id="observacoes"
                  type="textarea"
                  name="observacoes"
                  value={formRepresentante.observacoes}
                  label="Observações"
                  onChange={handleChangeForm}
                />
              </Col>
            </CustomRow>
            <BarraInferiorBotoes>
              {updating ? (
                <WorkspaceBotoes
                  delete
                  onClickDelete={handleDelete}
                  save
                  onClickSave={handleUpdate}
                />
              ) : (
                <WorkspaceBotoes inserir onClickInserir={handleCreate} />
              )}
            </BarraInferiorBotoes>
          </WorkspaceFicha>
        </Modal>

        <BoxConteudo boxTitulo="Filtros" fechado>
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="15%">
              <Select
                name="cargoFuncao"
                value={formFiltros.cargoFuncao}
                options={cargoOptions}
                onChange={handleChangeFiltros}
                label="Cargo"
              />
            </CustomCol>
            <CustomCol width="40%">
              <Input
                id="nomeCompleto"
                name="nomeCompleto"
                value={formFiltros.nomeCompleto}
                label="Nome"
                onChange={handleChangeFiltros}
              />
            </CustomCol>
            <CustomCol width="20%">
              <Input
                id="celular"
                name="celular"
                // mascara="celular"
                value={formFiltros.celular}
                label="Celular"
                onChange={handleChangeFiltros}
              />
            </CustomCol>
            <CustomCol width="25%">
              <Input
                id="email"
                name="email"
                value={formFiltros.email}
                label="email"
                onChange={handleChangeFiltros}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersHistoricoRT}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidos}
          onRowClick={handleRowClickUsuarioVinculado}
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          // downloadDisabled={}
          onClickDownload={() =>
            ExportToExcel(
              exportData,
              valoresExibidos,
              fieldObject,
              'sisaf_fornecedores_representantes.xlsx',
              userID,
              'DAF',
              entity,
            )
          }
          /* inserir
          onClickInserir={handleClickInserirNovo}*/
          inserir
          onClickInserir={handleShowModalVinculoUsuario}
        />
      </BarraInferiorBotoes>
      <Modal
        tituloModal="Detalhes do Usuário Vinculado"
        open={showModal && !!usuarioVinculadoSelecionado}
        onHide={() => {
          setShowModal(false);
          setUsuarioVinculadoSelecionado(null);
        }}
      >
        <WorkspaceFicha>
          {usuarioVinculadoSelecionado && (
            <>
              <Log
                dataRegistro={usuarioVinculadoSelecionado.dataVinculacao}
                usuarioRegistro={
                  usuarioVinculadoSelecionado.usuarioVinculacao?.nomeCompleto ||
                  '---'
                }
              />

              <CustomRow>
                <CustomCol width="30%">
                  <Input
                    id="cpf-usuario-vinculado"
                    label="CPF"
                    value={usuarioVinculadoSelecionado.usuarioId?.cpf || '---'}
                    readonly
                    onChange={(e) => void e}
                  />
                </CustomCol>
                <CustomCol width="70%">
                  <Input
                    id="nome-usuario-vinculado"
                    label="Nome Completo"
                    value={
                      usuarioVinculadoSelecionado.usuarioId?.nomeCompleto ||
                      '---'
                    }
                    readonly
                    onChange={(e) => void e}
                  />
                </CustomCol>
              </CustomRow>

              <CustomRow>
                <CustomCol width="50%">
                  <Input
                    id="email-usuario-vinculado"
                    label="Email"
                    value={
                      usuarioVinculadoSelecionado.usuarioId?.emailPessoal ||
                      '---'
                    }
                    readonly
                    onChange={(e) => void e}
                  />
                </CustomCol>
                <CustomCol width="50%">
                  <Input
                    id="celular-usuario-vinculado"
                    label="Celular"
                    value={
                      usuarioVinculadoSelecionado.usuarioId?.celular || '---'
                    }
                    readonly
                    onChange={(e) => void e}
                  />
                </CustomCol>
              </CustomRow>

              <CustomRow>
                <CustomCol width="50%">
                  <Input
                    id="data-vinculacao"
                    label="Data de Vinculação"
                    value={formatDate(
                      usuarioVinculadoSelecionado.dataVinculacao,
                    )}
                    readonly
                    onChange={(e) => void e}
                  />
                </CustomCol>
                <CustomCol width="50%">
                  <Input
                    id="status-vinculacao"
                    label="Status"
                    value={
                      usuarioVinculadoSelecionado.statusInterface === 'S'
                        ? 'Ativo'
                        : 'Pendente'
                    }
                    readonly
                    onChange={(e) => void e}
                  />
                </CustomCol>
              </CustomRow>
              <CustomRow>
                <CustomCol width="50%">
                  <Input
                    id="perfil-usuario-vinculado"
                    label="Perfil"
                    value={
                      tiposVinculo[
                        usuarioVinculadoSelecionado.tpVinculo as 1 | 2
                      ] || '---'
                    }
                    readonly
                    onChange={(e) => void e}
                  />
                </CustomCol>
              </CustomRow>

              <CustomRow>
                <Col>
                  <Input
                    id="observacoes-vinculacao"
                    label="Observações"
                    value={usuarioVinculadoSelecionado.observacao || '---'}
                    type="textarea"
                    readonly
                    onChange={(e) => void e}
                  />
                </Col>
              </CustomRow>

              <BarraInferiorBotoes></BarraInferiorBotoes>
            </>
          )}
        </WorkspaceFicha>
      </Modal>
    </>
  );
}

export default HistoricoRT;
